import React, { useMemo } from "react"
import { useSummaryData } from "../hooks/useSummaryData"
import { ClassName_EUIRollingCostsCharts } from "./summaryChartClassnames"
import { EUIRollingCostsBaseChart } from "@/components/base-chart/EUIRollingCostsBaseChart/EUIRollingCostsBaseChart"

export const config = {
  title: 'Monthly Electricity and Gas Costs',
}

export const EUIRollingCostsCharts = ({ period, endingMonth }) => {

  const { data: electricityData = {
    electricity: [],
  } } = useSummaryData('electricity', period, endingMonth)
  const { data: gasData = {
    gas: []
  } } = useSummaryData('gas', period, endingMonth)

  return (
    <EUIRollingCostsBaseChart
      electricityData={electricityData.electricity}
      gasData={gasData.gas}
      title={config.title}
      className={ClassName_EUIRollingCostsCharts}
      style={{ width: '100%', height: '100%' }}
    />
  )
}